import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-praise-first',
  	templateUrl: './toolcards-praise-first.component.html',
  	styleUrls: ['./toolcards-praise-first.component.scss']
})
export class ToolcardsPraiseFirstComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
  	}

}
